<template>
	<div>
		<Loader :show="loading" type="inline" />

		<table class="table" v-if="!loading">
			<tr class="table-head">
				<td>Nombre</td>
				<td>Fecha de pago</td>
				<td class="text-right">Monto</td>
			</tr>

			<tr v-for="item of list" :key="item.id">
				<td>
					<div class="tc">
						<span class="bolder">{{ item.order.client.name }} {{ item.order.client.lastname }}</span>
						<div class="text-secondary">
							{{ item.order.client.email }} - {{ item.order.client.phone.national || "" }}
						</div>
					</div>
				</td>

				<td>
					<div class="tc" v-if="item.order">
						<span class="bolder">{{ item.order.paidAt | moment("DD-MM-YYYY HH:mm") }} </span>
						<span class="text-secondary">
							#{{ item.order.transactions.find((t) => t.status == "PAID").referenceTransactionId || "" }}
						</span>
					</div>
				</td>
				<td>
					<div class="tc text-right">
						<span class="bolder">{{ item.currencySymbol }} {{ item.price | toCurrency }}</span>
					</div>
				</td>
			</tr>
		</table>

		<div class="alert p-5 text-center" v-if="!loading && list.length == 0">
			No se han encontrado membresías vendidas
		</div>

		<Pagination :pageData="pagination" @pageChange="pageChange" />
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "MembershipSellsTable",
	props: {
		membershipTypeId: {
			type: String
		}
	},
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $status: String, $membershipTypeId: String) {
							memberships(
								take: $take
								skip: $skip
								search: $search
								status: $status
								membershipTypeId: $membershipTypeId
							) {
								data {
									id
									currency
									currencySymbol
									price
									order {
										id
										paidAt
										transactions {
											id
											referenceTransactionId
											status
										}
										client {
											id
											name
											lastname
											email
											phone {
												national
											}
										}
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search,
						status: "PAID",
						membershipTypeId: this.membershipTypeId
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.memberships.data
					this.pagination.pageInfo = data.memberships.pageInfo
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
